// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"220":"39963e54","291":"212ba844","414":"6032f689","517":"edcf6414","551":"ba0400e5","572":"051ebab7","680":"f8e3bd3a","717":"cb35059b","809":"051ebab7"}[chunkId] + ".chunk.css";
};